import { IAdminUser } from "@lib/admin-users.interface";
import { IHandleData } from "@app/shared/directives/redactor/util";

export enum UsergroupsInclusions {
  SHOW_ALL = 'show_all',
  INCLUDE = 'include',
  EXCLUDE = 'exclude',
}

export type FieldType = 'teaserText' | 'confirmationText';
export type DrawerType = 'complianceSettings' | 'signupPageSettings' | 'ipRestrictionSettings' | 'socialConnectSettings';

export interface IAdminsSelections {
  selectedApprovers: IAdminUser[],
  selectedAdminsIDs: IAdminUser[],
}

export const SIGNUP_PAGE_TITLE: string = 'Signup Page Settings';
export const IP_RESTRICTION_TITLE: string = 'IP Restriction Settings';
export const SOCIAL_CONNECT_TITLE: string = 'Social Connect Settings';
export const COMPLIANCE_ADD_TITLE: string = 'Add Compliance Document';
export const COMPLIANCE_EDIT_TITLE: string = 'Edit Compliance Document';
export const ALERT_MESSAGE: string = 'SMS Verification can only be enabled if SMS is activated.';
export const DefaultConfirmationText: (clientName: string) => string = (clientName: string): string => {
  return `
    <p>Thank you for joining us!</p>
    <p>Your account has been successfully created. You're now part of our community.</p>
    <p>Feel free to explore our platform and discover all the features we offer.</p>
    <p>If you have any questions or need assistance, our support team is here to help.</p>
    <p>Welcome aboard!</p>
    <p>Best regards,</p>
    </br>
    <p>${clientName} Team</p>
  `;
};

export const DefaultTeaserText: (clientName: string) => string = (clientName: string): string => {
  return `
    <h1>Welcome to ${clientName}</h1>
    <p>This is my teaser text...</p>
  `;
};

export const TEASER_TEXT_HANDLE_ITEMS: IHandleData = {
  item1: {
    item: 'Company Name',
    replacement: '{{company_name}}',
  },
  item2: {
    item: 'Site Manager Name',
    replacement: '{{site_manager_name}}',
  },
  item3: {
    item: 'Site Manager Email',
    replacement: '{{site_manager_email}}',
  },
};

export type IPAccessControlModeType = 'whitelist' | 'blacklist';
export type UsergroupsInclusionsValues = UsergroupsInclusions[keyof UsergroupsInclusions];